/**
 * JoinMeetingButton — opens a Teams join URL via the Teams SDK when running
 * inside Teams desktop, or `window.open` in dev. Never displays the URL
 * itself (per Bill's no-GUID, customer-first rule).
 */

import { useState } from 'react';
import { Button } from '@/components/primitives';
import { openTeamsJoinLink } from '../services/graphMeetingsClient';

export interface JoinMeetingButtonProps {
  joinWebUrl: string;
  /** Override the button label (default "Join meeting"). */
  label?: string;
}

export function JoinMeetingButton({ joinWebUrl, label = 'Join meeting' }: JoinMeetingButtonProps): JSX.Element {
  const [busy, setBusy] = useState<boolean>(false);
  return (
    <Button
      size="sm"
      variant="primary"
      disabled={busy}
      onClick={async () => {
        setBusy(true);
        try {
          await openTeamsJoinLink(joinWebUrl);
        } finally {
          setBusy(false);
        }
      }}
      aria-label="Join Microsoft Teams meeting"
    >
      <span aria-hidden style={{ marginRight: 6 }}>💻</span>
      {label}
    </Button>
  );
}
